import React from "react";
import { Box, Typography, Container } from "@mui/material";

const Usage = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        pb: { xs: 4, md: 5 }, // add padding bottom to make space for the image
      }}
    >
      {/* Background with text */}
      <Box
        sx={{
          width: { xs: "100%", md: "90%" },
          bgcolor: "#F9FAFB",
          borderTopLeftRadius: "15px",
          borderTopRightRadius: "15px",
          py: { xs: 6, md: 10 },
          px: 2,
          textAlign: "center",
        }}
      >
        <Container maxWidth="md">
          <Typography variant="h2">Usage of MetaTrader 5</Typography>
          <Typography
            sx={{
              mt: 5,
              fontSize: { xs: "1rem", sm: "1.125rem", md: "1.25rem" },
              color: "#607085",
              mx: "auto",
              fontWeight: 400,
              lineHeight: 1.6,
              maxWidth: 700,
            }}
          >
            Harness a full suite of analytic power—fundamental and technical analysis,
            real-time trading signals, and cutting-edge algorithms—to elevate every trade.
            Plus, stay in the loop with live financial news broadcasts, so you’re always
            ahead of market moves.
          </Typography>
        </Container>
      </Box>

      {/* Image (half-overlapping) using negative margin */}
      <Box
        sx={{
          width: { xs: "90%", sm: "85%", md: "90%" },
          mt: -3, // negative margin to pull image upward into the section
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0px 8px 30px rgba(0,0,0,0.1)",
        }}
      >
        <img
          src="/Images/houseusage.png"
          alt="MetaTrader Usage"
          style={{
            width: "100%",
            height: "500px",
            objectFit: "cover",
            display: "block",
          }}
        />
      </Box>
    </Box>
  );
};

export default Usage;
